import { useEffect, useState, type FC } from 'react';
import { useFormatters } from '@/hooks/useFormatters';

interface Props {
  timestamp: number;
  /** Formato corto («hace 5 s», «hace 3 min») y «ahora» por debajo de 5 s. */
  short?: boolean;
}

const SHORT_OPTIONS: Intl.RelativeTimeFormatOptions = { numeric: 'auto', style: 'short' };
const NOW_THRESHOLD_MS = 5000;

const TimeElapsed: FC<Props> = ({ timestamp, short = false }) => {
  const { formatRelativeTime } = useFormatters();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  if (!short) return formatRelativeTime(timestamp, null, null, now);
  // `numeric: 'auto'` sobre 0 segundos da «ahora» ya localizado.
  if (now - timestamp < NOW_THRESHOLD_MS)
    return formatRelativeTime(0, 'second', SHORT_OPTIONS, now);
  return formatRelativeTime(timestamp, null, SHORT_OPTIONS, now);
};

export default TimeElapsed;
